import axios from 'axios';
import { ApiEndpoints } from './urls';
import { drfQueryParams } from './utils';

class PeopleDataApi {
  // ------ Users API ------
  static getAllUsers(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(
      page,
      pageSize,
      filters,
      sorted,
      false
    );
    return axios.get(ApiEndpoints.userList, { params });
  }

  static getAllUsersWithSupervisor(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    params.include_supervisor = 'true';
    return axios.get(ApiEndpoints.userList, { params });
  }

  // ------ User Account API ------
  static getUserAccount({ id }) {
    return axios.get(ApiEndpoints.userDetail.replace(':id:', id));
  }

  static createUserAccount(params) {
    const url = ApiEndpoints.userList;
    return axios.post(url, params);
  }

  static updateUserAccount(data) {
    const { id } = data;
    return axios.put(ApiEndpoints.userDetail.replace(':id:', id), data);
  }

  // ------ User Profile API ------
  static getUserProfile({ id }) {
    return axios.get(ApiEndpoints.userProfile.replace(':id:', id));
  }

  static updateUserProfile(data) {
    const { id } = data;
    return axios.put(ApiEndpoints.userProfile.replace(':id:', id), data);
  }

  // ------ User Travel Profile API ------
  static getUserTravelProfile({ id }) {
    return axios.get(ApiEndpoints.userTravelProfile.replace(':id:', id));
  }

  static updateUserTravelProfile(data) {
    const { id } = data;
    return axios.patch(ApiEndpoints.userTravelProfile.replace(':id:', id), data);
  }

  static updateUserTravelRoutes(data) {
    const { id } = data;
    return axios.patch(ApiEndpoints.userTravelProfile.replace(':id:', id), data);
  }

  // ------ User Travel Profile API ------
  static getUserTravelRoutes({ id }) {
    return axios.get(ApiEndpoints.userTravelProfile.replace(':id:', id));
  }
}

export default PeopleDataApi;
